export default __webpack_public_path__ + "static/media/cctv-blue.050b90d5.png";